import { useReactiveVar } from '@apollo/client';
import { EuiFormLabel } from '@elastic/eui';
import { powerInHP } from 'cache';
import { RangeFilter } from 'components/RangeFilter/RangeFilter';
import { powerInHpOptions, motoPowerInHpOptions } from 'enums/G';
import { useIntl } from 'react-intl';
import { getOptions } from 'utils';
import { WHITE_LABELS } from 'CONST';

import * as S from './FiltersSidebar.styles';

export const PowerInHPFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const options = useReactiveVar(powerInHP);

  const getPowerInHpOptionsByDomain = (): typeof powerInHpOptions | typeof motoPowerInHpOptions => {
    const whiteLabel = window.WHITE_LABEL_CONFIG;
    switch (whiteLabel?.name) {
      case WHITE_LABELS.MOTORCYCLE:
        return motoPowerInHpOptions;
      case WHITE_LABELS.CAR:
      default:
        return powerInHpOptions;
    }
  };

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.powerInHP.label' })}</EuiFormLabel>
      <RangeFilter
        values={options as { min: string; max: string }}
        onChange={powerInHP}
        data={getOptions(getPowerInHpOptionsByDomain())}
      />
    </S.SidebarFilterWrapper>
  );
};
